<template>
  <div>
    <van-nav-bar title="用工关系邀请"></van-nav-bar>

    <div v-if="invitateShow && !isFecthingData">
      <div class="result">
        <van-icon name="question" size="60px" color="#3dbd7d"></van-icon>
        <p class="title">收到了用工关系邀请</p>
        <p class="info">来自：{{merchantName}}</p>
      </div>

      <div class="invitate-button">
        <van-button plain hairline type="info" icon="cross" size="large" @click="ignore">忽略</van-button>
        <van-button class="confirm-button" icon="success" type="info" size="large" @click="accept">接受</van-button>
      </div>
    </div>


    <div v-if="!invitateShow && !isFecthingData">
      <div class="result">
        <van-icon name="info" size="60px" color="#f6c844"></van-icon>
        <p class="title">数据有误</p>
        <p class="info">无法查到邀请数据，请忽略</p>
      </div>

      <div class="invitate-button">
        <van-button plain hairline type="info" size="large" @click="goBack">返回</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {productFlag} from "../../../assets/js/weixin"
import { API } from './../../../assets/js/api'
import { NavBar, Icon, Button, Toast, Dialog } from "vant"
export default {
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      isFecthingData: true,
      invitateShow: false,
      invitationId: null,
      merchantName: ''
    }
  },
  created() {
    this.invitationId = this.$route.params.invitationId;
    this.getInvitationInfo();
  },
  methods: {
    getInvitationInfo() {
      this.isFecthingData = true;
      this.$loading();

      this.$http({
        url: API['get_bind_detail'],
        type: 'get',
        data: {
          invitationId: this.invitationId
        }
      }).then(res => {
        Toast.clear();
        this.isFecthingData = false;
        if(res.success) {
          this.invitateShow = true;
          this.merchantName = res.data.merchantName;
        } else {
          this.invitateShow = false;
          this.$message(res.msg)
        }
      }).catch(err => {
        Toast.clear();
        this.isFecthingData = false;
        console.log(err);
      })
    },
    ignore() {
      this.goBack();
    },
    accept() {
      this.$loading();

      this.$http({
        url: API['user_bind_employment'],
        type: 'get',
        data: {
          invitationId: this.invitationId
        }
      }).then(res => {
        Toast.clear();

        if(res.success) {
          Dialog.alert({
            message: '绑定成功',
            confirmButtonText: '返回个人页面'
          }).then(() => {
            this.goBack();
          }).catch(() => {

          })
        }
      })
    },
    goBack() {
      // this.$router.push('/netUser/home');
      if(productFlag) {
        window.location.replace('https://fwh.sionfend.com/ehctm_node/netUser.html')
      } else {
        window.location.replace('http://www.linkton.net:8090/ehctm/netUser.html')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.result {
  height: auto;
  text-align: center;
  padding: 22.5px 0;
  background-color: #fff;
}

.title {
  font-size: 18px;
  margin: 10px 0;
}

.info {
  font-size: 15px;
  color: #bbb;
}

.invitate-button {
  margin: 10px;
  display: flex;
  .confirm-button {
    margin-left: 10px;
  }
}
</style>


